
import { useSelector, useDispatch } from 'react-redux';
import { fetchInspectorTasksCounts } from '../modules/Inspector/tasksCounts';

const useInspectorAuthTasksCounts = ()=>{
    const dispatch = useDispatch()
    const InspectorAuth = useSelector(state => state.InspectorAuth);
    
    if(InspectorAuth&&InspectorAuth.authenticated){
        fetchInspectorTasksCounts()(dispatch)
    }
}


export default useInspectorAuthTasksCounts;